import { useAnalytics } from '@/shared/lib/analytics';

const analytics = useAnalytics();

export const { trackEvent, trackEventImmediately, useClickTracker, useViewTracker } = analytics;
